import { z } from 'zod';

import { makeFeatureFlagPayloadValidator } from './utils';

/**
 * Transcription evaluation configuration settings.
 *
 * When the transcriptionEvalWorkflow is enabled, these are the thresholds used
 * to determine whether a transcript has failed evaluation.
 */
export const transcriptionEvalConfigurations = makeFeatureFlagPayloadValidator({
  defaultEnabled: false,
  schema: z.object({
    zTextRepeat: z.object({
      maxRepeatCount: z.number().int().min(0),
      maxRepeatDensity: z.number().min(0).max(1),
    }),
  }),
  defaultValue: {
    zTextRepeat: {
      maxRepeatCount: 10,
      maxRepeatDensity: 0.3,
    },
  },
});
